import { useState, useEffect } from 'react';
import { Button, Row, Col, Modal, Form, Select, Input, InputNumber, Radio, Divider, DatePicker } from 'antd';
import { UploadOutlined, CheckSquareOutlined, CloseSquareOutlined } from '@ant-design/icons';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
import { PickerOverlay } from 'filestack-react';
import { PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import moment from 'moment';


const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 18 },
    sm: { span: 12 },
  },
};


const { Option } = Select;

const VehicleAddForm = ({ visible, onCreate, onCancel }) => {

  const [form] = Form.useForm();
  const [vehicleMakeData, setVehicleMakeData] = useState([])
  const [vehicleModelData, setVehicleModelData] = useState([])
  const [auctionData, setAuctionData]= useState([])
  const [buttonToggle, setButtonToggle] = useState(false)
  const [uploadDoneTrigger, setUploadDoneTrigger] = useState(false)

  useEffect(() => {
    const loadVehicleMakes = async () => {
      const makeResponse = await fetch(`${FetchVariable.Heroku}/make`)
      const vehicleMake = await makeResponse.json()

      setVehicleMakeData(vehicleMake)
    }

    loadVehicleMakes();
  }, []); // eslint-disable-line

  useEffect(() => {
    let aipURL = `${FetchVariable.Heroku}/auction/`
    axios.get(aipURL)
    .then((res)=>{
        let data = res.data
        setAuctionData(data)
    })
},[])

  const onVehicleMakeChange = makeId => {
    setVehicleModelData([])

    form.setFieldsValue({
      ModelID: null
    })

    const fetchModels = async () => {
      const modelsResponse = await fetch(`${FetchVariable.Heroku}/model/${makeId}/model`)
      const models = await modelsResponse.json()
      setVehicleModelData(models)
    }
    fetchModels()
  }

  const vColors = ["Red", "Blue", "Green",
    "Black", "White", "Gray",
    "Purple", "Yellow", "Gold",
    "Silver", "N/A"]

  const ImagePicker = () => {
    if (buttonToggle) {
      return (
        <PickerOverlay
          pickerOptions={{
            onClose: () => { setButtonToggle(false); setUploadDoneTrigger(false)}
          }}
          onError={(error) => console.log(error)}
          apikey={"AleCal6RpTNa6OEcJpvEQz"}
          onUploadDone={(res) => {
            setUploadDoneTrigger(true)
            form.setFieldsValue({
              ImageURL: res.filesUploaded[0].url
            });
          }}
        />
      )
    } else {
      return (
        null
      )
    }
  }

  const ImagePickerUploaded = () => {
    if(uploadDoneTrigger === true){
      return(
        <div>
          <CheckSquareOutlined style={{color: 'green', fontSize:'30px', marginRight:'-60px'}}/>
        </div>
      )
    }else{
      return (
        <div>
        <CloseSquareOutlined style={{color: 'red', fontSize:'30px', marginLeft:'-60px'}}/>
      </div>
      )
    }
  }

  return (
    <>
      <Modal
        visible={visible}
        title="Create a new Vehicle"
        okText="Create"
        cancelText="Cancel"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              form.resetFields();
              onCreate(values);
            })
            .catch((info) => {
              console.log('Validate Failed:', info);
            });
        }}
        width={800}

      >
        <Form
          form={form}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 14 }}
          name="VehicleForm"
          initialValues={{
            ModelID: '',
            AuctionID:'',
            VehicleStatus: 'N/A',
            VehicleColor: '',
            VehicleMPG: 0,
            VehicleMiles: 0,
            VehicleCondition: '',
            VehicleVIN: '',
            ImageURL: '',
            PurchasePrice: 0,
            PurchaseDate: '',
            SalesPrice: 0,
          }}
          {...formItemLayout}
        >
          <Divider> Vehicle Info *</Divider>

          <Row>
            <Col span={12}>
              <Form.Item
                label="Make"
                rules={[{ required: true, message: 'Please select vehicle make!' }]}
              >
                <Select 
                  onChange={onVehicleMakeChange} 
                  placeholder='Select Make'
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {vehicleMakeData?.map(Make => <Option value={Make.MakeID} key={Make.Make}>{Make.Make}</Option>)}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item 
                name="ModelID" 
                label="Model" 
                rules={[{ required: true, message: 'Please input vehicle model!' }]}
              >
                <Select>
                  {vehicleModelData?.map(Model => <Option value={Model.ModelID} key={Model.ModelID}>{Model.Model}</Option>)}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item 
              name='VehicleYear' 
              label="Year" 
              rules={[{ required: true, message: 'Please enter vehicle year!' }]}
              >
              <InputNumber min={1886} max={moment().year() + 1} style={{ width: '100%' }} />
            </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                validateTrigger='onBlur'
                name="VehicleVIN"
                label="VIN"
                maxLength={17}
                rules={[
                  { required: true, message: 'Please enter vehicle VIN!' },
                  { min: 17, max: 17, message: 'VIN Must be 17 Characters'}
                ]}
              >
                <Input showCount='true' maxLength={17} />
              </Form.Item>
              </Col>
          </Row>
          <Row>
            <Col span={12}>

            </Col>
          </Row>

          <Divider> Vehicle Condition </Divider>

          <Row>
            <Col span={12}>
              <Form.Item name="VehicleCondition" label="Condition">
                <Radio.Group style={{ width: '150%', marginLeft:'15px' }}>
                  <Radio value="Good">Good</Radio>
                  <Radio value="Fair">Fair</Radio>
                  <Radio value="Poor">Poor</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>

            <Col span={12}>
              {/* <Form.Item name="VehicleStatus" label="Status">
                <Select >
                  <Option value="Repair">Needs Repair</Option>
                  <Option value="ForSale">For Sale</Option>
                  <Option value="Arriving">Arriving</Option>
                  <Option value="N/A">N/A</Option>
                </Select>
              </Form.Item> */}
            </Col>
          </Row>

          <Row>
            <Col span={12}>
              <Form.Item name="VehicleMPG" label="MPG">
                <InputNumber min={0} max={100} step={1.0} style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="VehicleMiles" label="Miles">
                <InputNumber min={0} max={1000000} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>

        <Row>
          <Col span={12}>
          <Form.Item name="VehicleColor" label="Color">
            <Select 
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
              {vColors?.map(Color => <Option value={Color} key={Color}>{Color}</Option>)}
            </Select>
          </Form.Item>
          </Col>
          <Col span={12}>
          {/* <Form.Item 
            name='VehicleYear' 
            label="Year" 
            rules={[{ required: true, message: 'Please enter vehicle year!' }]}
            >
            <InputNumber min={1990} max={2030} style={{ width: '100%' }} />
          </Form.Item> */}
              <Form.Item name="VehicleStatus" label="Status">
                <Select >
                  <Option value="Repair">Needs Repair</Option>
                  <Option value="ForSale">For Sale</Option>
                  <Option value="Arriving">Arriving</Option>
                  <Option value="N/A">N/A</Option>
                </Select>
              </Form.Item>
          </Col>
        </Row>

          <Divider> Vehicle Prices </Divider>
        <Row>
          <Col span={12}>
            <Form.Item name="PurchasePrice" label="Purchase Price" rules={[{ required: true, message: 'Please enter purchase price!' }]}>
              <InputNumber prefix="$" style={{ width: '100%' }} />
            </Form.Item>
          </Col>

          <Col span={12}>
          <Form.Item
            name="PurchaseDate"
            label="Purchase Date"
            rules={[{ required: true, message: 'Please select purchase date!' }]}
          >
            {/* <PurchaseDatePicker/> */}
            <DatePicker format={"YYYY-MM-DD"}  />
          </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Form.Item name="SalesPrice" label="Sales Price">
              <InputNumber prefix="$" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="AuctionID"
              label="Auction"
            >
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {auctionData?.map(auction => <Option value={auction.AuctionID} key={auction.AuctionID}>{auction.AuctionName}</Option>)}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Divider> Vehicle Image </Divider>
          <Row>
          <Col span={12}>
            <Form.Item name='ImageURL' label="Image">
              <Button icon={<UploadOutlined />} onClick={() => setButtonToggle(true)}>
                Click to Upload
                <ImagePicker />
              </Button>
            </Form.Item>
          </Col>
          <Col span={12}>
            <ImagePickerUploaded />
          </Col>
        </Row>

        </Form>

      </Modal>
    </>
  )
}
const VehicleAdd = (props) => {
  const [visible, setVisible] = useState(false);

  const onCreate = (values) => {
    props.addVehicle(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}
        icon={<PlusOutlined />}
      >
        Add New Vehicle
      </Button>
      <VehicleAddForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
          this.formRef.current.resetFields()
        }}
      />
    </div>
  );
};

export default VehicleAdd